export default __webpack_public_path__ + "static/woningbouw-mobile-1b9e5d73682f988b0c11f86f073d9d90.svg";